export default {
  like: require('./like').default,
  answer: require('./answer').default,
  sender: require('./sender').default,
};
